import React, { useEffect } from 'react';
import IntegratedStimTable from './IntegratedStimTable';
import { StimTablePaginationBlock } from './StimTablePaginationBlock';




export default function TableWrapper({ stims, pgStimCount, loading, data, addStims, paginationState, onPageChange, onRowsPerPageChange, card, setCard, stimPosition, updateStep, updatedStimList, updatedStimArray, setUpdateStep, searched }) {

    useEffect(() => {
    }, [data])

    return <>
        <IntegratedStimTable
            loading={loading}
            data={data}
            addStims={addStims}
            pgStimCount={pgStimCount}
            stims={stims}
            stimPosition={stimPosition}
            updateStep={updateStep}
            updatedStimList={updatedStimList}
            updatedStimArray={updatedStimArray}
            setUpdateStep={setUpdateStep}
            searched={searched}
        />
        {paginationState ? (
            <div
                style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2,
                    background: "#fff",
                    padding: "8px 0",
                    borderTop: "1px solid rgba(0,0,0,0.08)",
                }}
            >
                <StimTablePaginationBlock
                    paginationState={paginationState}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                />
            </div>
        ) : (
            <></>
        )
        }
    </>;
}
